import { render, staticRenderFns } from "./freight_template_edit.vue?vue&type=template&id=b971ff40&scoped=true"
import script from "./freight_template_edit.vue?vue&type=script&lang=js"
export * from "./freight_template_edit.vue?vue&type=script&lang=js"
import style0 from "./freight_template_edit.vue?vue&type=style&index=0&id=b971ff40&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b971ff40",
  null
  
)

export default component.exports